import {Component, OnInit} from '@angular/core';
import {ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {Store} from '@ngxs/store';
import {AccessType} from '@app/modules/shared/data/constants';
import {CommandService} from '@app/services/command.service';
import {GameModeAction, GameModeModel, GameModeState} from '@app/state/game-mode.state';
import {LocalUser, LocalUserState} from '@app/state/local-user.state';
import {WrtcService} from '@app/modules/wrtc/services/wrtc.service';
import {CoreService} from '@app/services/core.service';

@Component({
  selector: 'app-game-mode',
  templateUrl: './game-mode.component.html'
})
export class GameModeComponent implements OnInit {
  roomStateInfo: ClassroomStateModel = ClassroomState.defaults;
  gameModeInfo: GameModeModel = GameModeState.defaults;
  localUser: LocalUser = LocalUserState.defaults;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  AccessType = AccessType;

  constructor(
    private store: Store,
    private commandService: CommandService,
    private wrtcService: WrtcService,
    private coreService: CoreService
  ) {}

  ngOnInit(): void {
    this.store.select(ClassroomState).subscribe(roomState => {
      this.roomStateInfo = roomState;
    });

    this.store.select(GameModeState).subscribe(gameModeState => {
      this.gameModeInfo = gameModeState;
    });

    this.store.select(LocalUserState).subscribe(currentUserState => {
      this.localUser = currentUserState;
    });

  }


  changeTeamName(teamIndex) {
    if (this.localUser.accessType === AccessType.TEACHER) {
      const team = this.gameModeInfo.teams[teamIndex];
      const teamNewName = prompt('Please enter a new team name', team.name);

      if (teamNewName) {
        this.store.dispatch(new GameModeAction.UpdateTeamName(teamIndex, teamNewName));
        this.coreService.sendTeamName(teamIndex, teamNewName).subscribe();
      }
    }
  }

  changeTeacherTeam(teamId) {
    if (this.gameModeInfo.teacherOnTeamId != null && this.gameModeInfo.teacherOnTeamId === teamId) {
      this.store.dispatch(new GameModeAction.TeacherLeaveTeam());
      this.wrtcService.sendTeacherTeam(null).subscribe();
    } else {
      const teamIndex = this.gameModeInfo.teams.findIndex(team => team.id === teamId);
      const teamName = this.gameModeInfo.teams[teamIndex].name;
      this.store.dispatch(new GameModeAction.TeacherSwitchToTeam(teamId));
      this.wrtcService.sendTeacherTeam(teamId).subscribe();
    }
  }
}
